<!--<app-data-table *ngIf="noOverlayPanel"-->
<!--                [columns]="tableColumns" [value]="chargeCodes" sortField="chargeNumber" [sortOrder]="PrimeNgConfig.TableAscSortOrder"-->
<!--                [disableSearch]="true" [disablePagination]="true" [disableEmptyMessage]="true"-->
<!--                [headerTemplate]="headerTemplate" [bodyTemplate]="bodyTemplate">-->

<!--  <ng-template #headerTemplate let-columns="columns">-->
<!--    <tr>-->
<!--      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngSwitch]="col.field">-->
<!--        {{col.header}}-->
<!--      </th>-->
<!--    </tr>-->
<!--  </ng-template>-->

<!--  <ng-template #bodyTemplate let-row="row" let-columns="columns">-->
<!--    <tr>-->
<!--      <td *ngFor="let col of columns" [ngSwitch]="col.field">-->
<!--        <span class="p-column-title">{{col.header}}</span>-->
<!--        <span class="p-cell">-->
<!--          <div *ngSwitchDefault>-->
<!--            <app-data-table-renderer [col]="col" [row]="row"></app-data-table-renderer>-->
<!--          </div>-->
<!--        </span>-->
<!--      </td>-->
<!--    </tr>-->
<!--  </ng-template>-->
<!--</app-data-table>-->

<table *ngIf="noOverlayPanel" class="table table-striped charge-code-list" style="width: 500px!important;min-width:200px!important;">
  <thead>
  <tr>
    <th style="width:40%;text-align: center;">Charge Code</th>
    <th style="width:20%;text-align: center">Allocation [%]</th>
    <th style="width:20%;text-align: center">Ext Price [$]</th>
    <th style="width:20%;text-align: center">Sales Tax [$]</th>
  </tr>
  </thead>

  <tbody>
  <tr *ngFor="let charge of chargeCodes; let i=index">
    <td style="text-align: center"> {{ charge.chargeNumber }} </td>
    <td style="text-align: right"> {{ charge.allocationPercent}}%</td>
    <td style="text-align: right"> {{ charge.allocationAmount | currency:Format.Currency }} </td>
    <td style="text-align: right"> {{ charge.taxAmount | currency:Format.Currency }} </td>
  </tr>
  </tbody>
</table>

<p-overlayPanel #overlayPanel appendTo="body" [showCloseIcon]="true" [dismissable]="true" (onAfterHide)="handleOPClose()" styleClass="ap-overlay" [style]="{'left':'0!important'}">
  <table class="table table-striped" style="width: 500px;">
    <thead>
    <tr>
      <th style="width:40%;text-align: center">Charge Code</th>
      <th style="width:20%;text-align: center">Allocation [%]</th>
      <th style="width:20%;text-align: center">Ext Price [$]</th>
      <th style="width:20%;text-align: center">Sales Tax [$]</th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let charge of chargeCodes; let i=index">
      <td style="text-align: center"> {{ charge.chargeNumber }} </td>
      <td style="text-align: right"> {{ charge.allocationPercent}}%</td>
      <td style="text-align: right"> {{ charge.allocationAmount | currency:Format.Currency }} </td>
      <td style="text-align: right"> {{ charge.taxAmount | currency:Format.Currency }} </td>
    </tr>
    </tbody>
  </table>
</p-overlayPanel>

<button *ngIf="!noOverlayPanel"
        pButton (click)="showCC($event,overlayPanel)" class="icon-action" icon="fa fa-external-link" aria-hidden="true"></button>
